import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["gap", "className", "spacingGroup", "flexDirection", "gx", "gy", "alignItems", "center"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Default from 'react-bootstrap/Row';
import { createResponsiveClasses } from '../utils/create-responsive-classes/create-responsive-classes';
import { jsx as _jsx } from "react/jsx-runtime";
export var Row = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var gap = _ref.gap,
      className = _ref.className,
      spacingGroup = _ref.spacingGroup,
      flexDirection = _ref.flexDirection,
      gx = _ref.gx,
      gy = _ref.gy,
      alignItems = _ref.alignItems,
      _center = _ref.center,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Default, _objectSpread(_objectSpread({}, rest), {}, {
    className: classNames(spacingGroup, className, {
      /**
       * We must us display flex when using the gap utility
       */
      'd-flex': gap || gx || gy
    },
    /**
     * We must use flex direction when using the gap utility
     * others the gaps will not be applied
     *
     * The directions are Row and Column which will either align
     * the columns next to each other `row` or in a stack `column`.
     */
    createResponsiveClasses({
      bsPrefix: 'flex',
      responsiveDefinitition: flexDirection
    }), createResponsiveClasses({
      bsPrefix: 'gap',
      responsiveDefinitition: gap
    }), createResponsiveClasses({
      bsPrefix: 'gx',
      responsiveDefinitition: gx
    }), createResponsiveClasses({
      bsPrefix: 'gy',
      responsiveDefinitition: gy
    }), createResponsiveClasses({
      bsPrefix: 'align-items',
      responsiveDefinitition: alignItems
    })),
    ref: ref
  }));
});